import {useState} from "react";

// Components

// Scss
import '../assets/css/partnerPortal/homepage.scss';
import '../assets/css/partnerPortal/welcome.scss';

import Image from "react-bootstrap/Image";
import ButtonArrow from "./ButtonArrow";


function CardLink(props) {



  const [icon] = useState(props.icon);
  const [link] = useState(props.link);
  const [buttonName] = useState(props.buttonName);
  const [width] = useState(props.width);

  return (
    <>
      
      <div className="trainingSection">
        <div className="frameRowSub">
          <Image src={icon} height={"150%"} />
          <ButtonArrow className="mt-2" link={link} buttonName={buttonName} width={width}/>
        </div>
      </div>
            
    </>
  );


}

export default CardLink;

